/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, bool } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";

import { Tag } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

const mergeEcheqData = (data = {}) => {
    const fromList = data.echeqList?.[0];
    if (fromList) {
        return { ...data, ...fromList };
    }
    return data;
};

const getQuantityAndCurrency = (object, raw) => {
    const amounts = object.transactionAmounts || {};
    const keys = Object.keys(amounts);
    if (keys.length > 0) {
        const currency = keys[0];
        return { currency, quantity: Number(amounts[currency]) || 0 };
    }
    if (raw.monto !== undefined && raw.monto !== null) {
        return {
            currency: String(raw.moneda ?? "0"),
            quantity: Number(raw.monto) || 0,
        };
    }
    const nestedAmount = raw.amount && typeof raw.amount === "object" ? raw.amount : null;
    if (nestedAmount !== null && nestedAmount.quantity !== undefined && nestedAmount.quantity !== null) {
        return {
            currency: String(nestedAmount.currency ?? "0"),
            quantity: Number(nestedAmount.quantity) || 0,
        };
    }
    return { currency: "0", quantity: 0 };
};

class EcheqRequestCertificateDataTable extends Component {
    static propTypes = {
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
    };

    dataRow = () => {
        const { multipleSignaturesData, isDesktop } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;

        return selectedTransactionRows.map((object) => {
            const { transaction } = object;
            const { idTransaction, data = {}, submitDateTimeAsString } = transaction;
            const raw = mergeEcheqData(data);
            const fechaPago = raw.fecha_pago;
            const chequeNumero =
                raw.cheque_numero === undefined || raw.cheque_numero === null ? "" : String(raw.cheque_numero);
            const echeqIdForTag = raw.cod_visualizacion || raw.cheque_id || "";
            const { currency, quantity } = getQuantityAndCurrency(object, raw);

            const content = (
                <div className="echeq-request-certificate-card__motivo-row">
                    <div className="echeq-request-certificate-card__first-line">
                        <span className="echeq-request-certificate-card__label">
                            <I18n id="multipleSignatures.echeqRequestCertificate.paymentDateLabel" />
                        </span>
                        {fechaPago ? (
                            <FormattedDate date={String(fechaPago)} showTime={false} withSpan />
                        ) : (
                            <span className="echeq-request-certificate-card__value" />
                        )}
                    </div>
                    <div className="echeq-request-certificate-card__second-line">
                        <span className="echeq-request-certificate-card__label">
                            <I18n id="multipleSignatures.echeqRequestCertificate.chequeNumberLabel" />
                        </span>
                        <span className="echeq-request-certificate-card__value">{chequeNumero}</span>
                        {echeqIdForTag && (
                            <Tag variant="info">
                                <I18n id="multipleSignatures.echeqRequestCertificate.echeqIdTagPrefix" />{" "}
                                {echeqIdForTag}
                            </Tag>
                        )}
                    </div>
                </div>
            );

            return (
                <CardContainer key={idTransaction} className="confirmation__cards-container mt-0">
                    <Card
                        isDesktop={isDesktop}
                        className="confirmation__cards echeq-request-certificate-card"
                        icon={isDesktop && "images/transfer-PENDING.svg"}
                        iconClass="card__pending-transaction-icon"
                        hrClass="d-none"
                        title={
                            !isDesktop && (
                                <div>
                                    {submitDateTimeAsString && (
                                        <div className="confirmation-cards__title">
                                            <div className="confirmation-cards__title-data">
                                                <I18n id="forms.transaction.ticket.date" />
                                            </div>
                                            <div className="confirmation-cards__title-info">
                                                <span>{submitDateTimeAsString}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        content={isDesktop ? content : <div>{content}</div>}
                        rightContent={
                            <div className="confirmation-cards__right">
                                <div className="confirmation-cards__right-data">
                                    <FormattedAmount currency={currency} quantity={quantity} />
                                </div>
                            </div>
                        }
                    />
                </CardContainer>
            );
        });
    };

    render() {
        return this.dataRow();
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(EcheqRequestCertificateDataTable));
